import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';

const AddUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        price: '',
        description: '',
        status: true
    });

    useEffect(() => {
        if (id) {
            getSingleData();
        }
    }, [id]);

    const getSingleData = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: `/admin/checkup-types/${id}`
            });
            if (response.data.status) {
                setFormData(response.data.data);
            } else {
                toast.error(response.data.message);
                navigate('/checkup-types');
            }
        } catch (error) {
            toast.error('Failed to fetch data');
            navigate('/checkup-types');
        } finally {
            setIsLoader(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: id ? 'PUT' : 'POST',
                url: id ? `/admin/checkup-types/${id}` : '/admin/checkup-types',
                data: formData
            });
            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/checkup-types');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Something went wrong');
            if (error.response && error.response.data && error.response.data.errors) {
                // Handle validation errors if needed
            }
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            {id ? 'Edit Checkup Type' : 'Add Checkup Type'}
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/checkup-types" className="btn btn-sm fw-bold btn-secondary">
                            Back
                        </Link>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-body py-4">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label required">Title</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-solid"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label required">Price</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control form-control-solid"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control form-control-solid"
                                        name="description"
                                        value={formData.description || ''}
                                        onChange={handleChange}
                                        rows="3"
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <div className="form-check form-switch form-check-custom form-check-solid">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="status"
                                            checked={formData.status}
                                            onChange={handleChange}
                                            id="statusSwitch"
                                        />
                                        <label className="form-check-label" htmlFor="statusSwitch">
                                            Enable
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                                        {isLoader ? 'Saving...' : 'Save Changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUpdate;
